// DatabaseToolbarButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './DatabaseToolbarButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * DatabaseToolbarButton
 * 
 * Renders a button in the database toolbar.
 *  
 *
 * @returns {ReactNode} - DatabaseToolbarButton.
 */
const DatabaseToolbarButton = React.memo(({ iconKey, label, title, onClick }) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover state

    const [hovered, setHovered] = useState(false);
    const hasIcon = !!iconKey;
    const hasLabel = Boolean(label);

    if (!hasIcon && !hasLabel) return null;

    // ----- RENDER ----- //

    return (

        <div
          className="database-toolbar-button-container"
          style={{
                backgroundColor: hovered ? theme.buttonHoverBackgroundColor : 'transparent',
            }}
          title={title}
          onClick={onClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >

            {iconKey && (
                <Icon
                  iconKey={iconKey}
                  color={hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted}
                  width={20}
                  height={20}
                />
            )}

            {/* LABEL */}
            {label && (

                <div
                  className="database-toolbar-button-label"
                  style={{
                        color: hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted,
                    }}
                >
                    {label}
                </div>
            )}

        </div>
    );

});

// Dev Tools
DatabaseToolbarButton.displayName = 'DatabaseToolbarButton';

export default DatabaseToolbarButton;
